import React from 'react';
import s from './Intro.scss';

class Intro extends React.Component {

  componentDidMount() {
    // window.componentHandler.upgradeElement(this.refs.root);
  }

  componentWillUnmount() {
    // window.componentHandler.downgradeElements(this.refs.root);
  }

  render() {
    return (
      <div className={s.wrapper}>
        <div className={s.content}>
          <h1 onClick={this.props.setContentView}>INTRO</h1>
        </div>
      </div>
    );
  }
}

Intro.propTypes = {
  setContentView: React.PropTypes.func.isRequired,
};

export default Intro;



/** WEBPACK FOOTER **
 ** ./components/Intro/Intro.js
 **/